import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, vModelRadio as _vModelRadio, withDirectives as _withDirectives, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-60e2113f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "policy-ownership-tab position-relative" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-secondary-title mb-3" }, "Policy ownership", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-content" }, [
  /*#__PURE__*/_createElementVNode("p", null, " As the insured, you can be the sole policy owner, or add another policy owner, or have someone else be the policy owner instead of you. "),
  /*#__PURE__*/_createElementVNode("p", null, "Important: All benefits will be paid to the policy owner/s.")
], -1))
const _hoisted_4 = { class: "negative-margin-row mb-3 row m-0" }
const _hoisted_5 = {
  key: 0,
  class: "item-secondary-title mb-3"
}
const _hoisted_6 = {
  key: 1,
  class: "item-secondary-title mb-3"
}
const _hoisted_7 = { class: "row m-0" }
const _hoisted_8 = { class: "row m-0" }
const _hoisted_9 = { class: "row m-0" }
const _hoisted_10 = { class: "negative-margin-row mb-3 row m-0" }
const _hoisted_11 = {
  key: 3,
  class: "px-0 mb-3"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-label mb-3" }, "Postal address", -1))
const _hoisted_13 = { class: "row col-12 mb-3 ms-0" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  for: "postal-same",
  class: "col-10 item-body align-self-center"
}, "Postal address is the same as my home address", -1))
const _hoisted_15 = { class: "row col-12 ms-0" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  for: "postal-different",
  class: "col-10 item-body align-self-center"
}, " Postal address is different ", -1))
const _hoisted_17 = {
  key: 4,
  class: "negative-margin-row mb-3 row m-0"
}
const _hoisted_18 = { key: 2 }
const _hoisted_19 = { class: "bg-info text-white p-2 mb-2 rounded" }
const _hoisted_20 = { class: "row overflow-x-hidden" }
const _hoisted_21 = { class: "col-lg-6 col-md-6 col-sm-6 col-xs-12 center-btn" }
const _hoisted_22 = { class: "col-lg-6 col-md-6 col-sm-6 col-xs-12 text-end center-btn" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingSpinnerWithBackground = _resolveComponent("LoadingSpinnerWithBackground")!
  const _component_SingleChoiceQuestionItem = _resolveComponent("SingleChoiceQuestionItem")!
  const _component_TextInputSmall = _resolveComponent("TextInputSmall")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_AddressDetails = _resolveComponent("AddressDetails")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_LoadingSpinnerWithBackground, { key: 0 }))
      : _createCommentVNode("", true),
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_SingleChoiceQuestionItem, {
        value: _ctx.policyOwnershipType.value,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.policyOwnershipType.value) = $event)),
        validationError: _ctx.errors['selectPolicyOwner'],
        "onUpdate:validationError": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.errors['selectPolicyOwner']) = $event)),
        title: _ctx.policyOwnershipType.text,
        options: _ctx.policyOwnershipType.options
      }, null, 8, ["value", "validationError", "title", "options"])
    ]),
    (_ctx.policyOwnerDetails && (_ctx.policyOwnershipType.value === 'both' || _ctx.policyOwnershipType.value === 'onlySomeoneElse'))
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (_ctx.policyOwnershipType.value === 'both')
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, " Secondary policy owner details "))
            : (_openBlock(), _createElementBlock("div", _hoisted_6, "Policy owner details")),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_TextInputSmall, {
              value: _ctx.policyOwnerDetails.firstName,
              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.policyOwnerDetails.firstName) = $event)),
              title: 'First name',
              class: "px-0 mb-4 me-2",
              "validation-error": _ctx.readError('firstName')
            }, null, 8, ["value", "validation-error"]),
            _createVNode(_component_TextInputSmall, {
              value: _ctx.policyOwnerDetails.middleName,
              "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.policyOwnerDetails.middleName) = $event)),
              title: 'Middle name (optional)',
              class: "px-0 mb-4 me-2",
              "validation-error": _ctx.readError('middleName')
            }, null, 8, ["value", "title", "validation-error"]),
            _createVNode(_component_TextInputSmall, {
              value: _ctx.policyOwnerDetails.lastName,
              "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.policyOwnerDetails.lastName) = $event)),
              title: 'Last name',
              class: "px-0 mb-4 me-2",
              "validation-error": _ctx.readError('lastName')
            }, null, 8, ["value", "validation-error"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_DatePicker, {
              value: _ctx.policyOwnerDetails.dateOfBirth,
              "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.policyOwnerDetails.dateOfBirth) = $event)),
              description: '(Must be 18 years old or older)',
              title: 'Date of birth',
              "max-value": _ctx.dobMaxDate,
              "validation-error": _ctx.readError('dateOfBirth'),
              class: _normalizeClass(["px-0 mb-4", {'me-2' : !_ctx.isMobileScreen}]),
              "is-mobile-screen": _ctx.isMobileScreen
            }, null, 8, ["value", "description", "max-value", "validation-error", "class", "is-mobile-screen"]),
            _createVNode(_component_TextInputSmall, {
              value: _ctx.policyOwnerDetails.email,
              "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.policyOwnerDetails.email) = $event)),
              title: 'Email address',
              class: "px-0 mb-4 me-2",
              "validation-error": _ctx.readError('email')
            }, null, 8, ["value", "validation-error"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_TextInputSmall, {
              value: _ctx.policyOwnerDetails.mobile,
              "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.policyOwnerDetails.mobile) = $event)),
              title: 'Mobile',
              class: "px-0 mb-4 me-2",
              "validation-error": _ctx.readError('mobile')
            }, null, 8, ["value", "validation-error"]),
            _createVNode(_component_TextInputSmall, {
              value: _ctx.policyOwnerDetails.workPhone,
              "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.policyOwnerDetails.workPhone) = $event)),
              title: 'Work phone',
              class: "px-0 mb-4 me-2",
              "validation-error": _ctx.readError('workPhone')
            }, null, 8, ["value", "validation-error"])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_SingleChoiceQuestionItem, {
              value: _ctx.homeAddressType,
              "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.homeAddressType) = $event)),
              validationError: _ctx.errors['selectPolicyOwnerHomeAddress'],
              "onUpdate:validationError": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.errors['selectPolicyOwnerHomeAddress']) = $event)),
              title: 'Home Address',
              options: _ctx.homeAddressOptions
            }, null, 8, ["value", "validationError", "options"])
          ]),
          (_ctx.homeAddressType)
            ? (_openBlock(), _createBlock(_component_AddressDetails, {
                key: 2,
                value: _ctx.policyOwnerDetails.addresses[0],
                "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.policyOwnerDetails.addresses[0]) = $event)),
                "home-address": _ctx.homeAddressType,
                errors: _ctx.errors['addresses[0]']
              }, null, 8, ["value", "home-address", "errors"]))
            : _createCommentVNode("", true),
          (_ctx.homeAddressType)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _hoisted_12,
                _createElementVNode("div", _hoisted_13, [
                  _withDirectives(_createElementVNode("input", {
                    id: "postal-same",
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.isPostalAddressSame) = $event)),
                    type: "radio",
                    class: "col-2 form-check-input radio-check-booster-blue item-content",
                    value: true
                  }, null, 512), [
                    [_vModelRadio, _ctx.isPostalAddressSame]
                  ]),
                  _hoisted_14
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _withDirectives(_createElementVNode("input", {
                    id: "postal-different",
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.isPostalAddressSame) = $event)),
                    type: "radio",
                    class: "col-2 form-check-input radio-check-booster-blue item-content",
                    value: false
                  }, null, 512), [
                    [_vModelRadio, _ctx.isPostalAddressSame]
                  ]),
                  _hoisted_16
                ])
              ]))
            : _createCommentVNode("", true),
          (!_ctx.isPostalAddressSame)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                _createVNode(_component_SingleChoiceQuestionItem, {
                  value: _ctx.postalAddressType,
                  "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.postalAddressType) = $event)),
                  validationError: _ctx.errors['selectPolicyOwnerPostalAddress'],
                  "onUpdate:validationError": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.errors['selectPolicyOwnerPostalAddress']) = $event)),
                  title: 'Postal Address',
                  options: _ctx.postalAddressOptions
                }, null, 8, ["value", "validationError", "options"])
              ]))
            : _createCommentVNode("", true),
          (!_ctx.isPostalAddressSame && _ctx.postalAddressType)
            ? (_openBlock(), _createBlock(_component_AddressDetails, {
                key: 5,
                value: _ctx.policyOwnerDetails.addresses[1],
                "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.policyOwnerDetails.addresses[1]) = $event)),
                "postal-address": _ctx.postalAddressType,
                errors: _ctx.errors['addresses[1]']
              }, null, 8, ["value", "postal-address", "errors"]))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true),
    _createElementVNode("hr", {
      class: _normalizeClass(["hr medium-bottom-spacing", { 'd-none': _ctx.isMobileScreen }])
    }, null, 2),
    (_ctx.errorMsg && _ctx.errorMsg.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("span", null, _toDisplayString(_ctx.errorMsg), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_20, [
      _createElementVNode("div", _hoisted_21, [
        (_ctx.previousPath)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              class: _normalizeClass(["btn btn-booster-secondary float-start", { 'd-none': _ctx.isMobileScreen }]),
              to: _ctx.previousPath
            }, {
              default: _withCtx(() => [
                _createTextVNode("Back")
              ]),
              _: 1
            }, 8, ["class", "to"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_22, [
        (_ctx.nextPath)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "btn btn-booster-primary float-end",
              onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.goToNextPage()))
            }, " Next "))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}